'use strict'

import Vue from 'vue'
// import * as type from './types'
import actions from './actions'

const state = {
  isFetching: false,
  error: null,
  data: {}
}

const mutations = {

  // Every action should call this at begining, clear error and set isFetching (f.e. for loading FE state)
  START_OPERATION (state) {
    state.isFetching = true
    state.error = null
  },

  // commit it whenewer operation ends with error, in state.error is saved error message
  OPERATION_ERROR (state, action) {
    state.isFetching = false
    state.error = action.error
  },

  CREATE_ORGANIZATION (state, data) {
    Vue.set(state.data, data.id, data.organization)
    // TODO: use this organization as user's
    state.isFetching = false
    state.error = null
  },

  ADD_ORGANIZATION (state, data) {
    Vue.set(state.data, data.id, data.organization)
    state.isFetching = false
    state.error = null
  },

  REMOVE_ORGANIZATION (state, data) {
    Vue.delete(state.data, data.id)
    state.isFetching = false
    state.error = null
  },

  CONNECT_ORGANIZATION (state, data) {
    // TODO: connect with organization
    state.isFetching = false
    state.error = null
  },

  DISCONNECT_ORGANIZATION (state, data) {
    // TODO: connect with organization
    state.isFetching = false
    state.error = null
  },

  CHANGE_ORGANIZATION_NAME (state, data) {
    Vue.set(state.data[data.id], 'name', data.name)
    state.isFetching = false
    state.error = null
  },

  CHANGE_ORGANIZATION_ADDRESS (state, data) {
    Vue.set(state.data[data.id], 'address', data.address)
    state.isFetching = false
    state.error = null
  },

  CHANGE_ORGANIZATION_DESCRIPTION (state, data) {
    Vue.set(state.data[data.id], 'description', data.description)
    state.isFetching = false
    state.error = null
  },

  ADD_ORGANIZATION_TO_GROUPS (state, data) {
    if (!state.data[data.id].groups) {
      state.data[data.id].groups = []
    }
    state.data[data.id].groups.push(data.groups)
    state.isFetching = false
    state.error = null
  },

  REMOVE_ORGANIZATION_FROM_GROUPS (state, data) {
    let newGroups = state.data[data.id].groups.filter(el => {
      return !data.groups.includes(el)
    })
    Vue.set(state.data[data.id], 'groups', newGroups)
    state.isFetching = false
    state.error = null
  },

  GET_ORGANIZATION (state, data) {
    Vue.set(state.data, data.payload.id, data.payload)
    state.isFetching = false
    state.error = null
  },

  GET_LOCATIONS_LIST (state, data) {
    if (state.data[data.organizationID].locations === undefined) {
      Vue.set(state.data[data.organizationID], 'locations', {})
    }
    for (let i = 0; i < data.payload.length; i++) {
      // if location already fetched, dont waste time
      if (state.data[data.organizationID].locations[data.payload[i].id] === undefined) {
        Vue.set(state.data[data.organizationID].locations, data.payload[i].id, data.payload[i])
      }
    }
    state.isFetching = false
    state.error = null
  },

  GET_LOCATION_DETAIL (state, data) {
    if (state.data[data.organizationID].locations === undefined) {
      Vue.set(state.data[data.organizationID], 'locations', {})
    }
    if (state.data[data.organizationID].locations[data.payload.id] === undefined) {
      Vue.set(state.data[data.organizationID].locations, data.payload.id, { detail: {} })
    }
    Vue.set(state.data[data.organizationID].locations[data.payload.id], 'detail', data.payload)
    state.isFetching = false
    state.error = null
  },

  GET_CONTACTS_LIST (state, data) {
    if (state.data[data.organizationID].contacts === undefined) {
      Vue.set(state.data[data.organizationID], 'contacts', {})
    }
    for (let i = 0; i < data.payload.length; i++) {
      // if contact already fetched, dont waste time
      if (state.data[data.organizationID].contacts[data.payload[i].id] === undefined) {
        Vue.set(state.data[data.organizationID].contacts, data.payload[i].id, data.payload[i])
      }
    }
    state.isFetching = false
    state.error = null
  },

  GET_CONTACT_DETAIL (state, data) {
    if (state.data[data.organizationID].contacts === undefined) {
      Vue.set(state.data[data.organizationID], 'contacts', {})
    }
    if (state.data[data.organizationID].contacts[data.payload.id] === undefined) {
      Vue.set(state.data[data.organizationID].contacts, data.payload.id, { detail: {} })
    }
    Vue.set(state.data[data.organizationID].contacts[data.payload.id], 'detail', data.payload)
    state.isFetching = false
    state.error = null
  }
}

export default {
  state,
  mutations,
  actions
}
